import {BehaviorSubject} from "rxjs";
import {StoreConstants} from '../constants/store.constants';

export const UserActions = {
  user: (user: any) => ({
    group: StoreConstants.StoreGroups.User,
    type: StoreConstants.User.USER,
    user
  }),
  user$: (user$: BehaviorSubject<any>) => ({
    group: StoreConstants.StoreGroups.User,
    type: StoreConstants.User.USER$,
    user$
  }),
  userPhoto: (userPhoto: any) => ({
    group: StoreConstants.StoreGroups.User,
    type: StoreConstants.User.USER_PHOTO,
    userPhoto
  }),
  userPhoto$: (userPhoto$: any) => ({
    group: StoreConstants.StoreGroups.User,
    type: StoreConstants.User.USER_PHOTO$,
    userPhoto$
  }),
  session: (session: any) => ({
    group: StoreConstants.StoreGroups.User,
    type: StoreConstants.User.SESSION,
    session
  }),
  session$: (session$: BehaviorSubject<any>) => ({
    group: StoreConstants.StoreGroups.User,
    type: StoreConstants.User.SESSION$,
    session$
  }),
  activationPending$: (activationPending$: BehaviorSubject<boolean>) => ({
    group: StoreConstants.StoreGroups.User,
    type: StoreConstants.User.ACTIVATION_PENDING$,
    activationPending$
  }),
  signedIn$: (signedIn$: BehaviorSubject<boolean>) => ({
    group: StoreConstants.StoreGroups.User,
    type: StoreConstants.User.SIGNED_IN$,
    signedIn$
  })
};
